import { OptionsApi } from '@core/swagger-client';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$webinarId/insights')({
    // As the overview: the page is complete on the first render, so a back link restores its scroll position.
    loader: {
        handler: async ({ context, params: { webinarId } }) => {
            if (!context.isAuthenticated) return;
            const { queryClient } = context;
            const ignore = () => undefined;
            await Promise.all([
                queryClient.ensureQueryData(OptionsApi.dashboard.getContentSummary(webinarId)).catch(ignore),
                queryClient.ensureQueryData(OptionsApi.insights.getChatMessagesCount(webinarId)).catch(ignore),
                queryClient.ensureQueryData(OptionsApi.survey.get(webinarId)).catch(ignore),
                queryClient.ensureQueryData(OptionsApi.exam.get(webinarId)).catch(ignore)
            ]);
        },
        staleReloadMode: 'blocking'
    }
});
